import template from './edit.html';
import { STATES } from '../../../../../constants';
import { actions, selectors } from '../../../../../state';
import './edit.global.css';

const MESSAGES = {
  SUCCESS: `We've updated your USPS mail forwarding form with your changes and we'll file the updated form with the USPS.`,
  ERROR: 'Sorry. There was an error updating your form. Please try again.',
  CANCELLED: `Cancelled. We've cancelled this USPS mail forwarding form.`,
  CANCELLED_ERROR: `Sorry, we are unable to cancel this USPS mail forwarding form. Please reach out to help@updater.com for further assistance.`,
};

class ForwardMailEditController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);

    // Not using connect since this is being connected to a form
    this.item = getItemFromState(this.id, getState());

    this.deleting = false;
  }

  get cancelSref() {
    return STATES.STEP_FORWARD_MAIL_LIST;
  }

  onSubmit(item) {
    const { dispatch } = this.updStore;

    const success = () => {
      dispatch(actions.router.stateGo(STATES.STEP_FORWARD_MAIL_LIST));
      dispatch(actions.message.success(MESSAGES.SUCCESS));
      dispatch(actions.analytics.track('Updated FYM', { id: this.id }));
    };

    const error = (response) => {
      dispatch(actions.message.error(MESSAGES.ERROR));
      dispatch(actions.analytics.track('Tried To Edit FYM', response));
    };

    dispatch(actions.item.singleton(this.id).update(item)).then(success, error);
  }

  onDelete(item) {
    const { dispatch } = this.updStore;

    this.deleting = true;

    const success = () => {
      dispatch(actions.router.stateGo(STATES.STEP_FORWARD_MAIL_LIST));
      dispatch(actions.message.success(MESSAGES.CANCELLED));
      dispatch(actions.analytics.track('Cancelled FYM', { item_id: this.id }));
    };

    const error = (error) => {
      this.deleting = false;
      dispatch(actions.message.error(MESSAGES.CANCELLED_ERROR));
      dispatch(
        actions.analytics.track('Error Cancelling FYM', {
          error,
          fym: { id: this.id, ...item },
        })
      );
    };

    dispatch(
      actions.item.singleton(this.id).update({ status: 'cancelled' })
    ).then(success, error);
  }
}

export const ForwardMailEditComponent = {
  template,
  controller: ForwardMailEditController,
};

function getItemFromState(id, state) {
  const item = selectors.item.byId(id);
  const move = selectors.move.byId(item.moveId(state));

  return {
    start_date: item.startDate(state),
    end_date: item.endDate(state),
    form_type: item.formType(state),
    name_id: item.nameId(state),
    business_name: item.businessName(state),
    from_address: move.fromAddress(state),
    to_address: move.toAddress(state),
  };
}

function mapStateToThis(state) {
  return {
    id: selectors.router.currentParamsId(state),
    submitting: selectors.pending.match(actions.item.isUpdate, state),
  };
}
